import React from "react";
import clsx from "clsx";

export default function Menu({deviceData, fullModalState, _handleBackToRooms, _onFullModalChange}) {
    return <div
        className={clsx(
            "card-rounded d-flex flex-stack flex-wrap",
            {'p-3': deviceData.menuAxis == 'x' && !deviceData.horizontalBlock},
            {'p-0 h-100': deviceData.menuAxis == 'x' && deviceData.horizontalBlock},
            {'h-100 flex-column align-items-start p-0': deviceData.menuAxis == 'y'}
        )}
    >
        <a
            href="#"
            className={clsx(
                "btn text-uppercase text-uppercase",
                {"shadow rounded-1" : deviceData.menuAxis == 'x' && !deviceData.horizontalBlock},
                {'fs-8 h-100 rounded-0 border-end border-gray-200': deviceData.menuAxis == 'x' && deviceData.horizontalBlock},
                {'text-center fs-8 px-1 py-2 rounded-0 w-100': deviceData.menuAxis == 'y'},
                {'btn-white': !fullModalState.rooms},
                {'btn-secondary': fullModalState.rooms},
            )}
            onClick={(e) => {
                e.preventDefault();
                _handleBackToRooms();
            }}
        >
            <i className="ki-duotone ki-abstract-9 fs-2">
                <span className="path1"></span>
                <span className="path2"></span>
            </i>
            {
                deviceData.horizontalBlock && <br/>
            }
            Rooms
        </a>


        {/*<div className="m-0">*/}
        {/*    <a*/}
        {/*        href="#"*/}
        {/*        className={clsx(*/}
        {/*            "btn text-uppercase text-uppercase",*/}
        {/*            {"shadow rounded-1" : deviceData.menuAxis == 'x' && !deviceData.horizontalBlock},*/}
        {/*            {'fs-8 h-100 rounded-0 border-end border-gray-200': deviceData.menuAxis == 'x' && deviceData.horizontalBlock},*/}
        {/*            {'text-center fs-8 px-1 py-2 rounded-0 w-100': deviceData.menuAxis == 'y'},*/}
        {/*            {'btn-white': !fullModalState.rooms},*/}
        {/*            {'btn-secondary': fullModalState.rooms},*/}
        {/*        )}*/}
        {/*        onClick={(e) => {*/}
        {/*            e.preventDefault();*/}
        {/*        }}*/}
        {/*    >*/}
        {/*        <i className="ki-duotone ki-setting-2 fs-2 p-0">*/}
        {/*            <span className="path1"></span>*/}
        {/*            <span className="path2"></span>*/}
        {/*        </i>*/}
        {/*    </a>*/}

        {/*    <div className="menu menu-sub menu-sub-dropdown w-250px w-md-300px d-block" data-kt-menu="true" data-popper-placement="bottom-end">*/}
        {/*        <div className="px-7 py-5">*/}
        {/*            <div className="mb-10">*/}
        {/*                <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">*/}
        {/*                    <input className="form-check-input" type="checkbox" name="showSelectors" onChange={(e) => {}} />*/}
        {/*                    <label className="form-check-label">Show Selectors & Configurators</label>*/}
        {/*                </div>*/}
        {/*            </div>*/}

        {/*        </div>*/}
        {/*    </div>*/}
        {/*</div>*/}

        {
            deviceData.horizontalBlock &&
            <a
                href="#"
                className={clsx(
                    "btn text-uppercase text-uppercase",
                    {"shadow rounded-1" : deviceData.menuAxis == 'x' && !deviceData.horizontalBlock},
                    {'fs-8 h-100 rounded-0 border-start border-gray-200': deviceData.menuAxis == 'x' && deviceData.horizontalBlock},
                    {'text-center fs-8 px-1 py-2 rounded-0 w-100': deviceData.menuAxis == 'y'},
                    {'btn-white': !fullModalState.products},
                    {'btn-secondary': fullModalState.products},
                )}
                onClick={(e) => _onFullModalChange(e, 'products', fullModalState.products ? false : true)}
            >
                <i className="ki-duotone ki-shop fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                    <span className="path4"></span>
                    <span className="path5"></span>
                </i>
                {
                    deviceData.horizontalBlock && <br/>
                }
                Products
            </a>
        }

        {/*<a href="/" className="fs-2 text-dark fw-bold align-middle">Hackrea, Visualizer</a>*/}
        {/*<ul className="nav flex-wrap border-transparent fw-bold">*/}
        {/*    <li className="nav-item my-1">*/}
        {/*        <a className="btn btn-color-gray-600 btn-active-secondary btn-active-color-primary fw-bolder fs-8 fs-lg-base nav-link px-3 px-lg-8 mx-1 text-uppercase " href="#">Overview </a>*/}
        {/*    </li>*/}
        {/*    <li className="nav-item my-1">*/}
        {/*        <a className="btn btn-color-gray-600 btn-active-secondary btn-active-color-primary fw-bolder fs-8 fs-lg-base nav-link px-3 px-lg-8 mx-1 text-uppercase" href="#">tickets </a>*/}
        {/*    </li>*/}
        {/*</ul>*/}

    </div>
}